// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3cE7w","item":"PaymentsMobile_item__eFRjC","label":"PaymentsMobile_label__9xaD4","amount":"PaymentsMobile_amount__1nrSD"};